import type { Column } from "@tanstack/react-table";
import type { DocumentRowFragment } from "../client/generated";
import { Button } from "@acdc2/ui/components/button";
import { Icon } from "@mdi/react";
import { useTranslation } from "react-i18next";
import {
  mdiArrowDownThin,
  mdiArrowUpThin,
  mdiEyeOff,
  mdiSwapVertical,
} from "@mdi/js";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@acdc2/ui/components/dropdown-menu";

type Props = {
  column: Column<DocumentRowFragment, string | string[]>;
  label: string;
};

export function DocumentTableHeader({ column, label }: Props) {
  const { t } = useTranslation();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="sm" variant="ghost" className="-ml-1">
          <span>{label}</span>
          {column.getCanSort() && (
            <Icon
              path={
                column.getIsSorted() === "asc"
                  ? mdiArrowUpThin
                  : column.getIsSorted() === "desc"
                    ? mdiArrowDownThin
                    : mdiSwapVertical
              }
              size="1rem"
            />
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {column.getCanSort() && (
          <>
            <DropdownMenuItem onClick={() => column.toggleSorting(false)}>
              <Icon path={mdiArrowUpThin} size="1rem" />
              {t("DocumentTableHeader.ascending")}
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => column.toggleSorting(true)}>
              <Icon path={mdiArrowDownThin} size="1rem" />
              {t("DocumentTableHeader.descending")}
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        )}
        {column.getCanHide() && (
          <DropdownMenuItem onClick={() => column.toggleVisibility(false)}>
            <Icon path={mdiEyeOff} size="1rem" />
            {t("DocumentTableHeader.hide")}
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
